<template>
  <div class="user-menu-box">
    <div class="menu-button" @click="(menu_flg == true) ? menu_flg = false : menu_flg = true">Ξ</div>
    <div class="main-box" :class="(menu_flg === true) ? 'small-menu' : ''">
      <h2 class="main-box-h2">MENU</h2>
      <ul>
        <li><a :class="current_menu(value.status)" v-for="(value, index) in menus" :key="index" @click="menu_chg(value.address)"><label>{{value.name}}</label></a></li>
      </ul>
      <a id="sidebar_logout" @click="logout">ログアウト</a>

    </div>
  </div>
</template>

<script>

export default {
  name: 'UserMenu',
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    status: 0,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      menus: [
        {name: '新規購入', address: 'uMain', status: 1},
        {name: '購入履歴', address: 'uHistory', status: 2},
        {name: '会員情報(編集)', address: 'uInfo', status: 3},
        {name: '退会手続き', address: 'uLeave', status: 4},
      ],
      menu_flg: false,
    };
  },
  computed: {
  },
  methods: {
    menu_chg (address) {
      this.$router.push({name: address, params: {}});
    },
    current_menu (status) {
      return this.status === status ? 'current_menu' : false;
    },
    logout () {
      location.href = `${this.$DF.BASE_URL}user?type=logout`;
    },
  },
};
</script>

<style lang="scss">
.user-menu-box {
  .main-box {
    position: fixed;
    left: 0;
    top: 0;
    font-weight: bold;
    height: 100%;
    z-index: 10;
    overflow: auto;
    letter-spacing: 0.075em;
    width: 208px;
    padding: 80px 0px 0px 16px;
    text-align: left;
    background: #faebeb;
  }
  .menu-button {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    top: 60px;
    background: #ccc;
    line-height: 3.3;
    font-weight: 800;
    color: #fefefe;
    cursor: pointer;
    display: none;
    z-index: 100;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .main-box-h2 {
    font-size: 20px;
    font-weight: bold;
    padding: 0px 0px 8px 0px;
    margin: 0px 0px 0px 0px;
  }

  ul {
    li {
      a {
        display: block;
        color: #da7d77;
        padding: 10px;
        width: 100%;
        text-decoration: none;
        transition: all 0.2s ease;
        font-size: 14px;

        cursor: pointer;
        label {
          padding: 0 0 0 8px;
          height: 24px;
          line-height: 24px;
          border-left: 6px solid #da7d77;
          display: inline-block;
          cursor: pointer;
        }
        &:hover{
          color: #1b2010;
          label {
            border-left: 6px solid #df274c;
          }
        }
      }
      a.current_menu{
        background-color: #fefefe;
        color: #1b2010;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        label {
          border-left: 6px solid #df274c;
        }
      }
    }
  }

  a#sidebar_logout {
      color: #ffffff;
      display: block;
      background-color: #7a1812;
      text-align: center;
      padding: 8px;
      margin: 30px 16px 0px 0px;
      text-decoration: none;
      transition: all 0.2s ease;
      border-radius: 6px;
      cursor: pointer;
    &:hover{
      background-color: #df274c;
    }
  }
}
@media (max-width: 767px) {
  .user-menu-box {
    .main-box {
      left: -300px;
      transition: all 0.3s ease;
    }
    .menu-button {
      display: block;
    }
    .small-menu {
      left: 0px;
      transition: all 0.3s ease;
    }
  }
}
</style>
